<template>
  <input
    v-bind="$attrs"
    type="text"
    class="w-full border border-grey-25 px-4 py-2 text-sm text-black"
    :class="classes"
    :readonly="readonly"
    :placeholder="placeholder"
    :name="name"
    :disabled="disabled"
    :value="val"
    :id="`inputText-${uuid}`"
    :aria-errormessage="`inputText-error-${uuid}`"
  />
  <span
    class="text-sm text-red-600"
    v-if="error"
    :id="`inputText-error-${uuid}`"
  >
    {{ errorMessage }}
  </span>
</template>

<script>
import input from 'Mixins/input';
import uuid from 'Mixins/uuid';

export default {
  name: 'InputText',
  mixins: [input, uuid],
  computed: {
    classes() {
      return {
        'bg-red-200': this.error,
      };
    },
  },
};
</script>
